import React, { useState } from 'react'
import { compose } from 'recompose'
import { Map } from 'immutable'
import { connect as connectRedux } from 'react-redux'
import FormsyForm from 'formsy-react'
import { getBoundActions } from '../../actions/index'
import { FEEDBACK_GIVEN_GA4_EVENT } from '../../services/event-tracking/index'
import { Textarea } from '../FormInput.v2/index'
import Button, { TYPES } from '../Button/index'
import { H4 } from '../Heading/index'

function VerticalVideoFeedback (props) {
  const {
    staticText,
    onClose,
    setEventDefault,
  } = props

  const [feedbackText, setFeedbackText] = useState('')

  const handleSubmit = () => {
    setEventDefault(FEEDBACK_GIVEN_GA4_EVENT.mergeDeep({
      comment: feedbackText,
      ui_location: 'shorts',
    }))
    setFeedbackText('')
    onClose()
  }

  const handleSkip = () => {
    onClose()
  }

  return (
    <div className="vertical-videos-page__video-feedback">
      <div
        className="vertical-videos-page__video-feedback-backdrop"
        onClick={onClose}
      >
        <div
          className="vertical-videos-page__video-feedback-dialog"
          onClick={(e) => e.stopPropagation()}
          role="dialog"
          aria-modal="true"
          aria-labelledby="vertical-videos-feedback-title"
        >
          <div className="vertical-videos-page__video-feedback-badge">
            <span className="vertical-videos-page__video-feedback-badge-label">
              {staticText.get('feedbackBetaLabel')}
            </span>
          </div>
          <H4
            className="vertical-videos-page__video-feedback-title"
            id="vertical-videos-feedback-title"
          >
            {staticText.get('feedbackTitle')}
          </H4>
          <p className="vertical-videos-page__video-feedback-description">
            {staticText.get('feedbackDescription')}
          </p>
          <FormsyForm
            className="vertical-videos-page__video-feedback-form"
            onValidSubmit={handleSubmit}
          >
            <Textarea
              label=" "
              name="feedback"
              className="vertical-videos-page__video-feedback-textarea"
              value={feedbackText}
              validations="maxLength:500"
              validationErrors={{
                maxLength: staticText.get('feedbackMaxLength'),
              }}
              onChange={(value) => setFeedbackText(value)}
              placeholder={staticText.get('feedbackPlaceholder')}
              rows={5}
              required
            />
            <Button
              type={TYPES.PRIMARY}
              submit
              className="vertical-videos-page__video-feedback-submit"
            >
              {staticText.get('feedbackButton')}
            </Button>
          </FormsyForm>
          <Button
            type={TYPES.LINK}
            className="vertical-videos-page__video-feedback-skip"
            onClick={handleSkip}
          >
            {staticText.get('skip')}
          </Button>
        </div>
      </div>
    </div>
  )
}

export default compose(
  connectRedux(
    (state) => {
      return {
        staticText: state.staticText.getIn(['data', 'verticalVideosPage', 'data'], Map()),
      }
    },
    (dispatch) => {
      const actions = getBoundActions(dispatch)
      return {
        setEventDefault: actions.eventTracking.setEventDefault,
      }
    },
  ),
)(VerticalVideoFeedback)
